<template>
  <div v-if="!error" class="pro-venue">
    <pro-venue-header @navigate="scrollTo" />
    <div class="pro-venue--content">
      <!-- Descripción para móviles -->
      <!-- <div v-if="venue.description" class="pro-venue--content__description">
        <h2 class="pro-venue--content__description--title">
          {{ $t("Descripción") }}
        </h2>
        <p class="pro-venue--content__description--text">
          {{ venue.description }}
        </p>
      </div> -->

      <!-- <div class="pro-venue--content__interest">
        <img
          src="@/assets/images/ic-heart-topaz.svg"
          alt="Heart Icon"
          class="pro-venue--content__interest--icon"
        />
        <span class="pro-venue--content__interest--text">
          {{ $t("Tambien te puede interesar") }}
        </span>
      </div> -->
      <pro-venue-events
        v-if="relatedEvents.length > 0"
        :related-events="relatedEvents"
        @on-select-date="onFilterEvents"
      />
      <div class="pro-venue--content__social">
        <div id="followers" class="pro-venue--content__social--followers">
          <span class="text-lg font-bold mb-2 block lg:hidden">
            {{ $t("profiles.labels.followers") }}
          </span>
          <w-shadow class="order-4 h-full">
            <template #contain>
              <followers-section
                :profile-followers="followers"
                :followers-count="venue.followers_count"
                type="Venue"
                @open-followers="showFollowersModal = true"
              ></followers-section>
            </template>
          </w-shadow>
        </div>
        <div id="chat" class="pro-venue--content__social--chat">
          <span class="pro-venue--content__social--chat__title">
            {{ $t("profiles.titles.chat") }}
          </span>
          <span class="pro-venue--content__social--chat__subtitle">
            {{ $t("wegow.chat.subtitle") }}
          </span>
          <article class="chat-container">
            <wegow-chat
              v-if="venue.id"
              :check-follow-user="checkFollowerUser"
              :chat-id="venue.id"
              :venue-id="venue.id"
              @update-event="updateVenue()"
            />
          </article>
        </div>
      </div>
      <pro-venue-moments
        v-if="momentStore.moments.length > 0"
        :related-moments="momentStore.moments"
      />
      <div
        v-if="geValidMedias(venueStore.media)?.length > 0"
        class="pro-venue--content__gallery"
      >
        <span class="pro-venue--content__gallery--title">{{
          $t("profiles.titles.gallery")
        }}</span>
        <span
          v-if="geValidMedias(venueStore.media)?.length > 2"
          class="pro-venue--content__gallery--see-all"
          @click="showGalleryModal = true"
        >
          {{ $t("general.header.dropdown.showAll") }}
        </span>
        <div class="relative">
          <gallery-section
            :images="geValidMedias(venueStore.media)"
            :navigation="false"
            type="venue"
          />
          <div class="slider-gradient"></div>
        </div>
      </div>
      <div class="pro-venue--content__how-to-get">
        <span class="pro-venue--content__how-to-get--title">
          {{ $t("profiles.titles.howToGet") }}
        </span>
        <div class="pro-venue--content__how-to-get--content">
          <div class="pro-venue--content__how-to-get--content__address">
            <span class="address">
              <img src="@/assets/images/ic-location-gray.svg" alt="Location" />
              {{ venue.address }}
            </span>
            <modal-google-maps
              :location="{
                longitude: venue.longitude,
                latitude: venue.latitude
              }"
            />
          </div>
          <div class="pro-venue--content__how-to-get--content--trip mt-3">
            <skyscanner-component direction="row" />
            <blablacar-component direction="row" />
          </div>
        </div>
      </div>
      <!-- Social media -->
      <div
        v-if="venue.links && venue.links.length > 0"
        class="pro-venue--content__social-media"
      >
        <social-media-links-section :links="venue.links" />
      </div>
      <div class="pro-venue--content__accommodation">
        <accommodation-section
          :location="{
            longitude: venue.longitude,
            latitude: venue.latitude
          }"
          :address="venue.address"
          :iso-code="venue.city?.iso_code"
        />
      </div>
    </div>
  </div>
  <not-found v-else :show-layout="false"></not-found>
  <modal-profiles
    v-if="showFollowersModal"
    :title="
      `${venue.followers_count} ${$t(
        'profiles.labels.followers'
      ).toLowerCase()}`
    "
    type="modal-large"
    @close="showFollowersModal = false"
  >
    <template #modalProfile>
      <section
        v-for="profile in followers"
        :key="profile.id"
        class="xs:block hidden"
      >
        <profile-card :profile="profile" type="profile-md-card" />
      </section>
      <section v-for="user in followers" :key="user.id" class="xs:hidden block">
        <user-card :user="user" />
      </section>
    </template>
  </modal-profiles>
  <modal-profiles
    v-if="showGalleryModal"
    :title="$t('profiles.titles.gallery')"
    type="medium"
    @close="showGalleryModal = false"
  >
    <template #modalProfile>
      <gallery-section
        :images="geValidMedias(venueStore.media)"
        :navigation="false"
        type="venue"
        :modal="true"
      />
    </template>
  </modal-profiles>
</template>

<script setup>
import ProVenueMoments from "@/components/general/ui/provenue/ProVenueMoments.vue";
import ProVenueEvents from "@/components/general/ui/provenue/ProVenueEvents.vue";
import FollowersSection from "@/components/general/ui/profiles/FollowersSection.vue";
import ProVenueFollowers from "@/components/general/ui/provenue/ProVenueFollowers.vue";
import WegowChat from "@/components/general/forms/complex-forms/WegowChat.vue";
import WegowLoader from "@/components/general/ui/WegowLoader";
import GallerySection from "@/components/wegow/ui/GallerySection.vue";
import ModalProfiles from "@/components/general/modals/ModalProfiles.vue";
import AccommodationSection from "@/components/wegow/event/AccommodationSection.vue";
import ModalGoogleMaps from "@/components/general/modals/ModalGoogleMaps.vue";
import SkyscannerComponent from "@/components/wegow/accommodations/SkyscannerComponent.vue";
import BlablacarComponent from "@/components/wegow/accommodations/BlablacarComponent.vue";
import ProfileCard from "@/components/wegow/ui/cards/ProfileCard.vue";
import UserCard from "@/components/general/ui/UserCard.vue";
import ProVenueHeader from "@/components/general/ui/provenue/ProVenueHeader.vue";
import SocialMediaLinksSection from "@/components/wegow/event/SocialMediaLinksSection.vue";
import NotFound from "@/views/general/NotFound";

import { useVenueStore } from "@/stores/modules/venue";
import { onBeforeMount, ref, defineAsyncComponent } from "vue";
import { useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { useEventStore } from "@/stores/modules/event";
import moment from "moment";
import { useUserStore } from "@/stores/modules/user";
import { useMomentStore } from "@/stores/modules/moment";

const WShadow = defineAsyncComponent(() =>
  import("@/components/general/ui/WShadow.vue")
);
const route = useRoute();

const venueStore = useVenueStore();
const eventStore = useEventStore();
const userStore = useUserStore();
const momentStore = useMomentStore();

const { details: venue } = storeToRefs(venueStore);
const { eventsToVenues: relatedEvents } = storeToRefs(eventStore);
const { venueFollowers: followers } = storeToRefs(userStore);

const showGalleryModal = ref(false);
const showFollowersModal = ref(false);
const checkFollowerUser = ref(false);
const error = ref(false);

onBeforeMount(async () => {
  const slug = route.params.slug;
  try {
    await venueStore.getDetails(slug);
    const venueId = venue.value.id;
    await Promise.all([
      eventStore.getEventsToVenues({ venue: venueId }),
      userStore.getVenueFollowers({ venue: venueId }),
      venueStore.getVenueMedia({ venue: venueId }),
      momentStore.getMoments({ tag_slug: slug, page_size: 10 })
    ]);
  } catch (err) {
    error.value = true;
  }
});

const onFilterEvents = async date => {
  const venueId = venue.value.id;
  const form_date = moment(date[0]).format("YYYY-MM-DD");
  const to_date = moment(date[1]).format("YYYY-MM-DD");
  await eventStore.getEventsToVenues({ venue: venueId, form_date, to_date });
};

const geValidMedias = media => {
  if (media?.length > 0) {
    return media.filter(m => m.type === 1 || m.thumbnails);
  } else {
    return [];
  }
};

const scrollTo = target => {
  const section = document.getElementById(target);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};

const updateVenue = async () => {
  console.log("updateo");
  checkFollowerUser.value = true;
};
</script>

<style lang="scss" scoped>
.pro-venue {
  @media screen and (max-width: 768px) {
    background: #071bf1;
  }
  background: #1c1d29;

  &--content {
    background: #1c1d29;
    padding: 1.75rem 0;
    max-width: 65rem;
    width: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    &__description,
    &__interest {
      display: none; // Ocultar por defecto
      padding: 1rem;
      border-radius: 10px;

      &--title {
        font-size: 1.25rem;
        font-weight: bold;
        margin-bottom: 0.5rem;
      }

      &--text {
        font-size: 1rem;
        color: #7f8295;
      }
    }

    &__social {
      @apply flex flex-col lg:flex-row w-full gap-4;
      &--followers {
        @apply w-full lg:w-fit;
        max-height: 400px;
        background: #000214;
        padding: 1.5rem;
        border-radius: 10px;
        position: relative; // Asegura que los elementos hijos se posicionen correctamente
        padding-top: 1rem; // Agrega espacio para el título
        &__title {
          font-size: 1.25rem;
          margin-bottom: 6px;
        }
      }
      &--chat {
        @apply w-full lg:w-full;
        max-height: 400px;
        background: #000214;
        padding: 1.5rem;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        &__title {
          font-size: 1.25rem;
          margin-bottom: 6px;
        }
        &__subtitle {
          font-size: 0.75rem;
        }
      }
    }
    &__moments {
      width: -webkit-fill-available;
      background: #000214;
      padding: 1.5rem;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      &--title {
        font-size: 1.25rem;
      }
      &--see-all {
        @apply text-sm;
        color: $topaz;
        margin-bottom: 14px;
      }
    }
    &__gallery {
      width: -webkit-fill-available;
      background: #000214;
      padding: 1.5rem;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      &--title {
        font-size: 1.25rem;
      }
      &--see-all {
        @apply text-sm;
        color: $topaz;
        margin-bottom: 14px;
      }
    }
    &__how-to-get {
      width: -webkit-fill-available;
      background: #000214;
      padding: 1.5rem;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      &--title {
        font-size: 1.25rem;
        margin-bottom: 14px;
      }
      &--content {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        &__address {
          & > .address {
            display: flex;
            gap: 0.5rem;
            font-size: 15px;
            color: #7f8295;
          }
          & > .map {
            font-size: 15px;
            color: $topazoscuro;
          }
        }
      }
    }
    &__social-media {
      background: #000214;
      padding: 1.5rem;
      border-radius: 10px;
    }
    &__accommodation {
      width: -webkit-fill-available;
      background: #000214;
      padding: 1.5rem;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      &--title {
        font-size: 1.25rem;
      }
    }
  }
  .chat-container {
    margin-top: 26.2px;
  }
}
@media (max-width: 768px) {
  .pro-venue--content {
    background-color: #000214 !important;

    // Elimina el border-radius de todos los elementos hijos
    * {
      border-radius: 0 !important;
    }
  }
  .pro-venue--content__description {
    display: block; // Mostrar solo en móviles
    margin-bottom: 1rem;
  }
  .pro-venue {
    &--content {
      &__interest {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;

        &--icon {
          width: 24px;
          height: 24px;
          margin-right: 0.5rem;
        }

        &--text {
          font-size: 1rem;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
#app > div > div > div > div.pro-venue--content__gallery > div > section >
div.carousel__viewport > ol
